import { Component, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { ChartComponent } from "ng-apexcharts";

import {
  ApexNonAxisChartSeries,
  ApexResponsive,
  ApexChart,
  ApexFill,
  ApexDataLabels,
  ApexLegend
} from "ng-apexcharts";
import { Observable, Subject, takeUntil } from 'rxjs';
import { AppState } from 'src/app/store/app.state';
import { getDashboardCounts } from 'src/app/store/selectors/account.selector';

export type ChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  responsive: ApexResponsive[];
  labels: any;
  fill: ApexFill;
  legend: ApexLegend;
  dataLabels: ApexDataLabels;
};

@Component({
  selector: 'app-pie-chart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.scss']
})
export class PieChartComponent implements OnInit {
  @ViewChild("chart") chart: ChartComponent;
  public chartOptions: Partial<ChartOptions>;

  getDashboardCounts$: Observable<any>;
  dashboardCounts: any

  ngUnsubscribe = new Subject<void>();

  constructor(
    private store: Store<AppState>
  ) {
    this.getDashboardCounts$ = this.store.select(getDashboardCounts);
  }

  ngOnInit() {
    this.getDashboardCounts$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res) => {
      if(res){
        this.dashboardCounts = res
        if(this.dashboardCounts){
          
        }
      }
    })
  }

  initializeChart(){
    this.chartOptions = {
      series: [this.dashboardCounts?.databaseCount, parseInt(this.dashboardCounts?.forVerificationCount)],
      chart: {
        width: "100%",
        type: "donut"
      },
      labels: [
        `Total (${this.dashboardCounts?.databaseCount})`,
        `For verification (${this.dashboardCounts?.forVerificationCount})`
      ], 
        dataLabels: {
        enabled: false
      },
      fill: {
        type: "gradient"
      },
      legend: {
        formatter: function(val, opts) {
          return val + " - " + opts.w.globals.series[opts.seriesIndex];
        }
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: "bottom"
            }
          }
        }
      ]
    };
  }

}
